import React, { Component } from "react";
import Modal from "react-responsive-modal";

import "./tools-modal.css";

class ToolsModal extends Component {
	render() {
		const { open, onClose, title, width = 540, context, footer, children } = this.props;

		return (
			<Modal
				open={open}
				onClose={onClose}
				center
				classNames={{ modal: "tools-modal", closeButton: "tools-modal__close" }}
				styles={{ modal: { width } }}
			>
				{title && <div className="tools-modal__title">{title}</div>}
				{context && <div className="tools-modal__context">{context}</div>}
				<div className="tools-modal__body">{children}</div>
				{footer && <div className="tools-modal__footer">{footer}</div>}
			</Modal>
		);
	}
}

export default ToolsModal;
